import { useEffect, useState } from "react"
import { EmployeeCodeItem } from './../model/EmployeCodeItem';
import { ClubFBItem } from './../model/ClubFBItem';
import { restAPIClient } from './../api/Client';

export function useFetchClubEmployeeCodes(data: ClubFBItem, attempt: number) {

    const [employeeCodesResponse, setEmployeeCodesResponse] = useState<EmployeeCodeItem[]>([]);

    useEffect(() => {
        const fetchItems = async () => {
            const token: any = data.ngaKey;
            restAPIClient.get(`/employee_codes.php?&course_id=${data.courseId}`, {
                headers: {
                    'X-Auth-Key': token
                }
            }).then((response) => {
                if (response.status === 200) {
                    try {
                        const ngaStatus = response.data["status"];
                        if (ngaStatus === "200") {
                            const employeeCodes = response.data["results"] as EmployeeCodeItem[];
                            setEmployeeCodesResponse(employeeCodes);
                        }
                    } catch (e) {
                        console.error("Error fetching codes: ", e);
                    }
                } else {
                    console.log(response);
                }
            });
        }
        fetchItems();
    }, [data, attempt]);

    return employeeCodesResponse;
}